<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GJMPHM/tc-custom/9781426806810.jpg?1728724861112" alt="This image is the cover for the book Taming the Playboy, The Sons of Lily Moreau"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taming the Playboy, The Sons of Lily Moreau
      </h1>
      <p class="bookDescription body article font2">
        <b>She was just what  the doctor ordered.</b><br/><br/>When he rescued Vienna Hollenbeck and  her grandfather from a fiery car wreck, Dr. Georges Armand wasn't prepared for his reaction to the petite blonde. Vienna aroused  his most protective instincts. And that didn't include the effect she was having on his libido.<br/><br/>An accident might have brought Blair Memorial's sexiest resident into Vienna's life, but she was no pushover. Falling for the handsome healer was a prescription for heartache. Unless she could show him that they shared something truly precious: the kind of love that comes along only once in  a lifetime
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Ferrarella
      </h2>
      
      <p class="authorDescription body article">This USA TODAY bestselling and RITA &reg; Award-winning author has written more than two hundred books for Harlequin Books and Silhouette Books, some under the name Marie Nicole. Her romances are beloved by fans worldwide. Visit her website at www.marieferrarella.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7a64f872